var _g, _g2, _g3, _g4, _g5, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7524_17965",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 34
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1497",
    d: "M17.5 0C20.8623 0 24.1491 0.997032 26.9447 2.86502C29.7403 4.733 31.9193 7.38804 33.206 10.4944C34.4927 13.6007 34.8293 17.0189 34.1733 20.3165C33.5174 23.6142 31.8983 26.6433 29.5208 29.0208C27.1433 31.3983 24.1142 33.0174 20.8165 33.6734C17.5189 34.3293 14.1007 33.9926 10.9944 32.706C7.88804 31.4193 5.233 29.2403 3.36502 26.4447C1.49704 23.6491 0.5 20.3623 0.5 17C0.5 12.4913 2.29107 8.1673 5.47919 4.97918C8.6673 1.79107 12.9913 0 17.5 0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7524_17965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2106",
    d: "M34.499 0H0.5V33.999H34.499V0Z",
    fill: "url(#paint0_linear_7524_17965)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7524_17965",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 31,
    height: 34
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1498",
    d: "M4.83398 13.795C4.83398 18.05 6.98496 22.77 10.74 24.972C11.9322 25.6689 13.2538 26.1159 14.6243 26.286C15.9948 26.456 17.3855 26.3455 18.7119 25.9612C20.0384 25.5768 21.2727 24.9266 22.34 24.0502C23.4072 23.1737 24.285 22.0894 24.92 20.863C24.3666 21.9203 23.5926 22.8464 22.6502 23.5785C21.7079 24.3106 20.6192 24.8317 19.458 25.1065C18.2967 25.3814 17.09 25.4035 15.9194 25.1714C14.7489 24.9392 13.6419 24.4584 12.6733 23.7612C11.7048 23.0641 10.8974 22.167 10.3057 21.1307C9.71401 20.0944 9.35187 18.943 9.24384 17.7546C9.1358 16.5662 9.28436 15.3684 9.67947 14.2424C10.0746 13.1163 10.707 12.0884 11.534 11.228C12.64 10.0374 14.0018 9.11347 15.5168 8.52576C17.0319 7.93805 18.6605 7.70192 20.2801 7.83518C21.8996 7.96845 23.4678 8.46762 24.8664 9.29507C26.265 10.1225 27.4575 11.2567 28.354 12.612C29.7201 14.8125 30.442 17.3519 30.438 19.942C30.438 20.092 30.438 20.242 30.43 20.392C30.3595 22.435 29.8402 24.4375 28.909 26.2573C27.9777 28.0772 26.6573 29.6697 25.0414 30.9219C23.4256 32.1741 21.5539 33.0553 19.5593 33.5029C17.5647 33.9506 15.4959 33.9537 13.5 33.512C15.6899 34.0437 17.9636 34.1346 20.189 33.7796C22.4144 33.4246 24.5469 32.6307 26.4627 31.444C28.3785 30.2573 30.0392 28.7016 31.3483 26.8673C32.6573 25.0331 33.5887 22.9568 34.0881 20.7593C34.5875 18.5618 34.645 16.287 34.2573 14.0671C33.8696 11.8472 33.0444 9.72651 31.8297 7.82841C30.6149 5.93031 29.035 4.29266 27.1816 3.01069C25.3283 1.72873 23.2386 0.828039 21.034 0.361006C19.1732 0.00785297 17.2593 0.0457413 15.414 0.472262C13.5687 0.898783 11.8323 1.70461 10.3152 2.83849C8.79816 3.97238 7.53365 5.40952 6.60205 7.05855C5.67046 8.70757 5.09216 10.5324 4.90396 12.417C4.85863 12.8703 4.83597 13.329 4.83597 13.793",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7524_17965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7524_17965",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 31,
    height: 34
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2108",
    d: "M34.5 0.124023H4.83398V33.999H34.5V0.124023Z",
    fill: "white"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7524_17965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2107",
    d: "M34.338 0.124023H4.83398V33.833H34.338V0.124023Z",
    fill: "url(#paint1_linear_7524_17965)"
  })))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 1500",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4999 8.521C19.1765 8.521 20.8155 9.01816 22.2095 9.94963C23.6035 10.8811 24.6901 12.205 25.3317 13.754C25.9733 15.303 26.1411 17.0074 25.8141 18.6518C25.487 20.2962 24.6796 21.8066 23.4941 22.9921C22.3085 24.1777 20.7981 24.985 19.1537 25.3121C17.5093 25.6392 15.8049 25.4713 14.2559 24.8297C12.707 24.1881 11.383 23.1016 10.4516 21.7076C9.5201 20.3135 9.02295 18.6746 9.02295 16.998C9.02295 14.7498 9.91605 12.5936 11.5058 11.0038C13.0955 9.4141 15.2517 8.521 17.4999 8.521Z",
    fill: "url(#paint2_radial_7524_17965)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7524_17965",
    x1: 17.4995,
    y1: 24.4793,
    x2: 17.4995,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7524_17965",
    x1: 29.3653,
    y1: 28.8585,
    x2: 21.8984,
    y2: 0.997809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5D35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5D35",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7524_17965",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6856 13.8106) scale(11.071 11.071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D3D3D3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo-circle.f70c67a43227f43b807f6b70e8016315.svg";
export { ForwardRef as ReactComponent };